<template>
  <div class="navigation_bar_container" :style="navigationBarStyle">
    <router-link
      tag="div"
      to="/mypage"
      class="mypage__navigation"
      v-if="needsShowTitleLogo"
      @click.native="reloadIfSameRoute()"
    >
      <img
        class="navigation_bar__title_logo"
        src="/img/logo_mark.png"
        height="18"
      />
    </router-link>
    <div class="navigation_bar__title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'NavigationBar',
  props: {
    title: String,
    showBorder: Boolean,
    navigationBarStyle: Object,
  },
  computed: {
    needsShowTitleLogo: function () {
      return this.title == null
    },
  },
  methods: {
    getMyPagePath: function () {
      return '/mypage'
    },
    reloadIfSameRoute: function () {
      // 現在のページがマイページな場合、リロードさせる
      if (this.getMyPagePath() === this.$route.path) {
        location.reload()
      } else {
        this.$router.push(this.getMyPagePath()).catch(() => {})
      }
    },
  },
}
</script>

<style scoped>
.navigation_bar_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 1;
}

/* SafeArea領域をカバーする疑似要素（スクロール時の透け防止） */
.navigation_bar_container::before {
  content: '';
  position: absolute;
  top: calc(-1 * var(--safe-area-inset-top, 0px));
  left: 0;
  right: 0;
  height: var(--safe-area-inset-top, 0px);
  background-color: #ffffff;
}
.navigation_bar_border {
  box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.1);
  border-bottom: #e8e8e8 1px solid;
}
.navigation_bar__title_logo {
  display: block;
}
.navigation_bar__title {
  font-family: sans-serif;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #262626;
}
</style>
